(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MainController', MainController);

    MainController.$inject = ['$state', 'Principal' ];

    function MainController($state, Principal) {
        var vm = this;
        vm.licence = null;
        getDomainName();

        function getDomainName() {
            Principal.identity().then(function(data) {
                vm.licence = data.context.licence.name;
            }, function(reason) {
                console.log('Couldn\'t get License name');
            });
        }
    }
})();
